import type {Props as ControlProps} from '@/components/ImageGalleryNextControl/components/Control';

import styled from '@emotion/styled';
import {IconChevronRight} from '@travel-frontend/icons';
import {useTranslation} from 'react-i18next';

import {Control} from '@/components/ImageGalleryNextControl/components/Control';

type Props = Omit<ControlProps, 'children' | 'position'> & {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  position?: ControlProps['position'];
};

export const ImageGalleryNextControl = styled(
  ({position, ...restProps}: Props) => {
    const {t} = useTranslation(['general']);

    return (
      <Control
        position={position ?? 'right'}
        {...restProps}
        aria-label={t('gallery.next')}
      >
        <IconChevronRight fontScale="large" />
      </Control>
    );
  }
)``;
